import { NgModule } from "@angular/core";
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [],
  imports: [
    NgxSpinnerModule
  ],
  exports: [
    NgxSpinnerModule
  ]
})
export class UtilsModule { }
